import { render, staticRenderFns } from "./PdfWidgetPanel.vue?vue&type=template&id=628c9de1&scoped=true"
import script from "./PdfWidgetPanel.vue?vue&type=script&lang=js"
export * from "./PdfWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./PdfWidgetPanel.vue?vue&type=style&index=0&id=628c9de1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c9de1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('628c9de1')) {
      api.createRecord('628c9de1', component.options)
    } else {
      api.reload('628c9de1', component.options)
    }
    module.hot.accept("./PdfWidgetPanel.vue?vue&type=template&id=628c9de1&scoped=true", function () {
      api.rerender('628c9de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/PdfWidgetPanel.vue"
export default component.exports